<template>
  <div class="ml-2">
    <validation-observer ref="observer">
      <div
        v-for="(item, index) in model"
        :key="index"
        class="mt-4 row align-items-center"
      >
        <div class="col-10 col-lg-6">
          <div
            class="d-flex align-items-center"
            :class="{
              'border-success': item.isCorrect,
            }"
          >
            <input class="custom-radio mr-3" disabled type="radio" />
            <div class="w-100">
              <validation-provider v-slot="{ errors }" rules="required">
                <custom-input
                  v-model="item.name"
                  custom-error-msg="El campo es requerido."
                  error-class="position-absolute"
                  :error="errors[0]"
                  :disabled="isReadOnly"
                />
              </validation-provider>
            </div>
          </div>
        </div>
        <div class="col-2 col-lg-6 pl-0">
          <div class="d-flex align-items-center">
            <div class="mw-15 mr-lg-3 mr-md-2">
              <i
                v-if="canQuit"
                class="pointer far fa-times-circle text-danger"
                @click="quit(index)"
              />
            </div>
            <div
              class="px-2"
              :class="{
                'border-success border rounded-pill': item.isCorrect,
              }"
              @click="markAsCorrect(index)"
            >
              <i
                class="fa-check-circle"
                :class="[
                  item.isCorrect ? 'fas text-success' : 'far text-muted',
                ]"
              ></i>

              <transition name="fade">
                <span v-if="item.isCorrect" class="text-success">
                  {{ isMobile ? '' : 'Respuesta Correcta' }}
                </span>
              </transition>
            </div>
          </div>
        </div>
      </div>

      <!-- Validación oculta: al menos una respuesta debe estar marcada como correcta -->
      <validation-provider
        v-slot="{ errors }"
        name="respuesta correcta"
        rules="hasCorrect"
      >
        <input type="hidden" :value="model" />
        <p v-if="errors.length" class="text-danger mt-2">
          {{ errors[0] }}
        </p>
      </validation-provider>

      <div v-if="canAdd" class="mt-4 d-flex align-items-center">
        <input class="custom-radio mr-3" disabled type="radio" />
        <u class="pointer text-success" @click="add">
          Agregar una opción
        </u>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import CustomInput from 'CustomInput';
import alertMixin from 'utils/mixins/alert.mixin';

import { extend } from 'vee-validate';

extend('hasCorrect', {
  message: 'Debe marcar al menos una respuesta como correcta.',
  validate(value) {
    return value.some((item) => item.isCorrect);
  },
});

export default {
  name: 'SimpleChoiceHorizontal',
  components: { CustomInput },
  mixins: [alertMixin],
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    min: {
      type: Number,
      default: () => 2,
    },
    max: {
      type: Number,
      default: () => 6,
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
    canAdd() {
      return !this.isReadOnly && this.model.length < this.max;
    },
    canQuit() {
      return this.model.length > this.min;
    },
  },
  async mounted() {
    if (this.model.length === 0) [...Array(this.min)].forEach(this.add);
  },
  methods: {
    markAsCorrect(index) {
      if (this.isReadOnly) {
        return;
      }

      this.model.forEach((x, i) => (x.isCorrect = i === index));
    },
    add() {
      if (!this.canAdd) return;
      const id = this.model.length + 1;
      this.model.push({ id, name: null, isCorrect: false });
    },
    async quit(index) {
      if (!this.canQuit) return;
      const confirmed = await this.ShowCancelModal(
        'Confirmación',
        '¿Está seguro que desea remover la opción de respuesta documentada?',
        'Si',
        'No'
      );
      if (!confirmed || this.model.length <= this.min) return;
      this.model.splice(index, 1);
    },
  },
};
</script>

<style scoped>
.mw-15 {
  min-width: 15px;
}
.text-gray {
  color: #9e9e9e !important;
}
.custom-radio {
  transform: scale(2.1);
  border: 1px solid #e2e2e2;
  appearance: none;
  width: 14px;
  height: 13px;
  border-radius: 50%;
  background-color: #f0f0f0;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.pointer {
  cursor: pointer;
}
.border-success ::v-deep input,
.border-success .custom-radio {
  border-color: #2db782;
}
</style>
